/* eslint-disable no-underscore-dangle */
/* eslint-disable arrow-body-style */
/* eslint-disable operator-linebreak */
import React, { useEffect, useState } from 'react';
import { TextField, Button, Tooltip, Autocomplete } from '@mui/material';
import PropTypes from 'prop-types';
import _ from 'lodash';

import { useForm, useFieldArray } from 'react-hook-form';
import CreateProduct from '../../Modal/CreateProduct';

import { AddSerialNumberDialog, AddOptionDialog } from '../../Dialogs';

import { SPM } from '../../../utils/Proptypes';

const resetValues = {
  product: '',
  amount: '',
};

export const ExportProductFormMany = ({
  errors,
  Controller,
  product,
  filterProduct,
  setFilterProduct,
  productList,
  setProductList,
  setReload,
  reload,
  setSelectWarehouse,
  selectWarehouse,
}) => {
  const [isModalCreateProductOpen, setIsModalCreateProductOpen] = useState(
    false,
  );
  const handleOpen = () => setIsModalCreateProductOpen(true);
  const handleClose = () => {
    setIsModalCreateProductOpen(false);
  };
  const [productLists, setProductLists] = useState([]);
  const { getValues, control, reset, setValue } = useForm({
    mode: 'onBlur',
  });

  // console.log('selectWarehouse in product form', selectWarehouse);
  // console.log('productLists in product form', productLists);
  // console.log('filterProduct in product form', filterProduct);

  useEffect(() => {
    if (selectWarehouse === null) {
      setProductLists([]);
    } else {
      const NewProductLists = _.map(selectWarehouse.inventory, (ep, index) => ({
        index: index + 1,
        ...ep.product,
        stock: ep.stock,
      }));
      setProductLists(NewProductLists);
    }
    setValue(null);
    setFilterProduct(null);
    // setReload(!reload);
    return () => { };
  }, [selectWarehouse]);

  useEffect(() => () => { }, [reload]);

  const handleScanBarcodes = (barcodeString) => {
    if (!selectWarehouse) {
      alert('กรุณาเลือกคลังสินค้า');
      return;
    }

    // แยก barcode เป็น array (รองรับ enter, comma, space)
    const barcodes = barcodeString
      .split(/[\n, ]+/)
      .map((b) => b.trim())
      .filter((b) => b);

    let updatedList = [...productList];
    let notFound = [];
    let outOfStock = [];

    barcodes.forEach((barcode) => {
      const foundProduct = productLists.find((item) => item.type_code === barcode);
      if (!foundProduct) {
        notFound.push(barcode);
        return;
      }

      const serialNumber = getValues('serialNumber') || '';
      const stock = foundProduct.stock || 0; // stock รวมของสินค้านี้ในคลัง

      // รวมจำนวนสินค้านี้จากทุก serial ที่อยู่ใน updatedList
      const totalAmountSameProduct = updatedList
        .filter(
          (p) =>
            p.product._id === foundProduct._id &&
            p.warehouse._id === selectWarehouse._id
        )
        .reduce((sum, p) => sum + parseInt(p.amount || 0), 0);

      // ถ้าเพิ่มอีก 1 แล้วเกิน stock → ห้ามเพิ่ม
      if (totalAmountSameProduct + 1 > stock) {
        outOfStock.push(barcode);
        return;
      }

      // หา index สำหรับ serial นี้
      const index = updatedList.findIndex(
        (p) =>
          p.product._id === foundProduct._id &&
          p.warehouse._id === selectWarehouse._id &&
          p.serialNumber === serialNumber
      );

      if (index > -1) {
        updatedList[index].amount = parseInt(updatedList[index].amount || 0) + 1;
      } else {
        updatedList.push({
          product: foundProduct,
          amount: 1,
          serialNumber,
          warehouse: selectWarehouse,
          stock: foundProduct.stock,
        });
      }
    });
    setProductList(updatedList);
    setReload(!reload);

    if (notFound.length > 0) {
      alert('ไม่พบสินค้าในคลัง');
    }
    if (outOfStock.length > 0) {
      alert('สินค้าเกินจำนวนคงเหลือในคลัง');
    }
  };

  return (
    <div>
      <CreateProduct
        isOpen={isModalCreateProductOpen}
        handleOnClose={handleClose}
      />
      <div className="flex flex-row flex-wrap">
        <div className="w-full px-1 py-2 flex ">
          <div className="flex-grow">
            {/* เพิ่ม input สำหรับยิงบาร์โค้ดหลายตัว */}
            <TextField
              label="สินค้า"
              multiline
              fullWidth
              size="small" // <<< ทำให้ input เองดูเล็กลงด้วย
              onBlur={(e) => {
                const barcodeString = e.target.value.trim();
                if (barcodeString) {
                  handleScanBarcodes(barcodeString);
                  e.target.value = '';
                }
              }}
              onKeyDown={(event) => {
                if (event.key === 'Enter' && !event.shiftKey) {
                  event.preventDefault();
                  const barcodeString = event.target.value.trim();
                  if (barcodeString) {
                    handleScanBarcodes(barcodeString);
                    event.target.value = '';
                  }
                }
              }}
            />
          </div>
          <div className="my-auto pl-1  flex-none">
            <Tooltip
              title="เพิ่มสินค้ากรณีที่ยังไม่มีข้อมูลในระบบ"
              placement="bottom"
            >
              <Button variant="outlined" onClick={handleOpen}>
                เพิ่มสินค้า
              </Button>
            </Tooltip>
          </div>
        </div>
        <div className="w-full px-1 py-1">
          <Controller
            name={'serialNumber'}
            control={control}
            defaultValue={''}
            rules={{ required: false }}
            render={({ field }) => (
              <TextField
                {...field}
                label="หมายเลขซีเรียล"
                fullWidth
                size={'small'}
                disabled={!selectWarehouse}
                helperText={errors.remark && 'กรุณาใส่ข้อมูล'}
              />
            )}
          />
        </div>
      </div>
    </div>
  );
};

ExportProductFormMany.propTypes = {
  errors: PropTypes.shape({
    product_transaction_type: PropTypes.object,
    orderNumber: PropTypes.billNumber,
    customer: PropTypes.array,
    source: PropTypes.object,
    quantity: PropTypes.object,
    price: PropTypes.object,
    product_stock_lots: PropTypes.object,
    warehouse: PropTypes.object,
    product_type: PropTypes.array,
    productionDate: PropTypes.object,
    expirationDate: PropTypes.object,
    receiptDate: PropTypes.object,
    sellDate: PropTypes.object,
    remark: PropTypes.object,
    recipientName: PropTypes.object,
    sellName: PropTypes.object,
    trackingNumber: PropTypes.object,
    sellPrice: PropTypes.object,
    shippingCost: PropTypes.object,
    discount: PropTypes.object,
    payment: PropTypes.payment,
  }),
  product: PropTypes.array,
  productType: PropTypes.array,
  productTransactionType: PropTypes.array,
  order: PropTypes.oneOf([SPM.Order, SPM.OrderArray]),
  Controller: PropTypes.func,
  control: PropTypes.object,
  type: PropTypes.object,
  setType: PropTypes.func,
  selectProduct: PropTypes.array,
  setSelectProduct: PropTypes.func,
  filterProduct: PropTypes.object,
  setFilterProduct: PropTypes.func,
  customers: PropTypes.array,
  departments: PropTypes.object,
  watch: PropTypes.func.isRequired,
  products: PropTypes.object,
  selectedProducts: PropTypes.array,
  setSelectedProducts: PropTypes.func,
  employees: PropTypes.array,
  productTypes: PropTypes.object,
  productList: PropTypes.array,
  setProductList: PropTypes.func,
  reload: PropTypes.bool,
  setReload: PropTypes.func,
  selectSerial: PropTypes.array,
  setSelectSerial: PropTypes.func,
  selectOption: PropTypes.array,
  setSelectOption: PropTypes.func,
  setSelectWarehouse: PropTypes.func,
  selectWarehouse: PropTypes.object,
};

ExportProductFormMany.defaultProps = {
  product: null,
  productType: null,
  productTransactionType: null,
  customer: null,
  department: null,
  me: null,
  type: null,
  selectProduct: null,
  filterProduct: null,
};

export default ExportProductFormMany;
